import * as ACTIONTYPES from '../constants/actiontypes'

import {
  getCurrentTime,
  getActiveFrame,
  getFrameCalculatedFromTime
} from '../selectors/selectors';
import {
  changeActiveFrame
} from './play-actions';

export const savePlayer = PLAYER => ({
  type: ACTIONTYPES.SAVE_PLAYER,
  PLAYER
});

export const initRealDuration = duration => ({
  type: ACTIONTYPES.INIT_REAL_DURATION,
  duration
});

export const currentTimeChange = currentTime => ({
  type: ACTIONTYPES.CURRENT_TIME_CHANGE,
  currentTime
});

export const updateTimeDuringPlayback = currentTime => (dispatch, getState) => {
  const state = getState();
  const previousTime = getCurrentTime(state);
  const previousFrame = getActiveFrame(state);

  if (Math.floor(currentTime) !== Math.floor(previousTime)) {
    dispatch(currentTimeChange(currentTime));
  }
  const currentFrame = getFrameCalculatedFromTime(getState());
  if (currentFrame !== previousFrame) {
    dispatch(changeActiveFrame(currentFrame));
  }

}




// WEBPACK FOOTER //
// ./src/store/actions/video-actions.js